<template>
  <div class="reportManage">
    <div class="listWarpper">
      <el-card  class="box-card " >
        <div slot="header" class="clearfix">
          <div class="opt">
            <el-select v-model="status" placeholder="请选择" @change="optChange">
              <el-option
                v-for="item in options"
                :key="item.status"
                :label="item.label"
                :value="item.status"
              ></el-option>
            </el-select>
          </div>
          <div class="opt">
            <el-date-picker
              is-range
              v-model="searchTime"
              type="daterange"
              align="center"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              @change="timeChange"
            ></el-date-picker>
          </div>
        </div>
        <div class="bd content_card">
          <div v-if="listData.length !=0">
            <el-table
                    align="center"
                    :data="listData"
                    height="500px"
                    border
                    style="width: 100%">
              <el-table-column
                      align="center"
                      prop="report_number"
                      label="编号"
                      width="180">
              </el-table-column>
              <el-table-column
                      prop="name"
                      align="center"
                      label="患者姓名"
                      width="180">
              </el-table-column>
              <el-table-column
                      prop="created"
                      align="center"
                      label="日期">
              </el-table-column>
              <el-table-column
                      prop="report_type_text"
                      align="center"
                      label="类型">
              </el-table-column>
              <el-table-column
                      prop=""
                      align="center"
                      label="操作">
                <template slot-scope="scope">
                <el-button
                        size="mini"
                        type="danger"
                        @click="reportDetail(scope.$index, scope.row)">预览</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="page">
              <el-pagination
                @current-change="currentPageChange"
                :page-size="pageList.pageSize"
                :current-page="pageList.pageNum"
                layout="total, prev, pager, next"
                :total="pageList.total"
              ></el-pagination>
            </div>
          </div>
          <div v-else class="empty">
            <emptyData />
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
const defalutAvatar = require("@/assets/images/defaultIcon.jpg");
import { reportList } from "@/api";
import pdf from "vue-pdf";
import util from "@/utils";
import emptyData from "@/components/common/emptyData.vue";

export default {
  name: "",
  components: { pdf, emptyData },
  props: {},
  data() {
    return {
      pageSize: 5,
      pageNum: 1,
      user: {},
      searchTime: [],
      listData: [],
      pageList: {},
      defalutAvatar: defalutAvatar,
      statusList: ["待确认", "已确认", "已拒绝"],
      tabName: "",
      report_type: "", //报告类型
      options: [
        {
          status: "-1",
          label: "全部"
        },
        {
          status: "1",
          label: "眼球阅片报告"
        },
        {
          status: "2",
          label: "处方报告"
        }
      ],
      status: "-1",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      value1: "",
      value2: ""
    };
  },
  mounted() {
    this.getReportList();
  },
  methods: {
    //时间搜索
    timeChange() {
      console.log("searchTime:", this.searchTime);
      this.getReportList();
    },
    /**
     * 选择状态
     */
    optChange() {
      console.log("status:", this.status);
      this.getReportList();
    },
    currentPageChange(val) {
      var that = this;
      that.pageNum = val;
      that.getReportList();
    },
    reportDetail(index,row) {
      window.open(
          row.pdf_url,
        "_blank",
        "location=yes,height=960,width=960,scrollbars=yes,status=yes"
      );
    },
    getReportList() {
      const that = this;
      let data = {
        status: that.status == "-1" ? "" : that.status,
        start_time:
          that.searchTime.length > 0 ? that.searchTime[0].getTime() : "",
        end_time:
          that.searchTime.length > 0 ? that.searchTime[1].getTime() : "",
        pageNum: that.pageNum,
        pageSize: that.pageSize
      };
      reportList(data).then(res => {
        var data = res.data;
        if (res.code == 1) {
          this.listData = data.data;
          this.pageList = res.data;
        }
      });
    },
    handleClose(done) {
      done();
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  padding: 20px;
  .c_img {
    flex: 0 0 10%;
    text-align: center;
    img {
      width: 100px;
    }
  }
  .text {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  .centerBox {
    flex: 0 0 65%;
    margin-left: 15px;
  }
  .right_box {
    flex: 0 0 25%;
    text-align: center;
    .c_btn {
      color: #FC701A;
      cursor: pointer;
    }
    .c_time {
      color: rgb(167, 157, 157);
    }
  }
}
.pdf span {
  display: block !important;
}
.reportManage {
  width: 80%;
  margin: 0 auto;
}
.reportManage .empty {
  width: 10%;
  height: 300px;
  margin: 0 auto;
  margin-top: 15%;
}
.opt {
  float: left;
}
.opt:nth-child(2) {
  margin-left: 20px;
}
.page {
  text-align: center;
}

</style>
